






















import { Component, Mixins } from 'vue-property-decorator';
import SFormElement from './SFormElement.vue';
import SInputBase from './SInputBase.vue';

@Component({
  components: {
    SInputBase,
  },
})
export default class SInput extends Mixins(SFormElement) {
}
